// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__K4Isc","footer":"ChangeClinic_footer__37iyl"};